import { render, staticRenderFns } from "./BSclassAdd.form.vue?vue&type=template&id=6bcdfe3c&"
import script from "./BSclassAdd.form.vue?vue&type=script&lang=js&"
export * from "./BSclassAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports